import { Action } from 'redux';
import { put, select } from 'redux-saga/effects';
import { ErrorAction, AppState } from 'store';
import { ACTION_CREATOR_NAME, analyticsHelper, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { PaymentActionTypes, PaymentActions } from 'store/payment';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface PaypalSetupPaymentAction extends Action<PaymentActionTypes.PAYPAL_SETUP_PAYMENT> {
    amount: number;
}

export interface PaypalSetupPaymentActionStart extends Action<PaymentActionTypes.PAYPAL_SETUP_PAYMENT_START> {
}

export interface PaypalSetupPaymentActionSuccess extends Action<PaymentActionTypes.PAYPAL_SETUP_PAYMENT_SUCCESS> {
    paymentCode: string;
}

export interface PaypalSetupPaymentActionError extends ErrorAction<PaymentActionTypes.PAYPAL_SETUP_PAYMENT_ERROR> {
}

export const paypalSetupPayment: (amount: number) => PaypalSetupPaymentAction = (amount: number) => ({
    type: PaymentActionTypes.PAYPAL_SETUP_PAYMENT,
    amount
});
paypalSetupPayment[ACTION_CREATOR_NAME] = 'paypalSetupPayment';

export type PaypalSetupPaymentFunc = (...args: Parameters<typeof paypalSetupPayment>) => void;

export function* paypalSetupPaymentSaga({ amount }: PaypalSetupPaymentAction): BasketSagaReturnType {
    yield put<PaymentActions>({
        type: PaymentActionTypes.PAYPAL_PAYMENT_START
    });
    yield put<PaymentActions>({
        type: PaymentActionTypes.PAYPAL_SETUP_PAYMENT_START
    });

    try {
        let state: AppState = yield select();
        const basket = state.basketState.basket!;

        sendAnalytics();

        const paymentCode = yield api.hybris.setupPaypalPayment(basket.user.name, basket.session.sessionId, amount);

        yield put<PaymentActions>({
            type: PaymentActionTypes.PAYPAL_SETUP_PAYMENT_SUCCESS,
            paymentCode
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.PAYPAL_SETUP_PAYMENT_ERROR,
            error: errorToBasketErrorModel(error, 'paypalSetupPaymentSaga')
        });
        yield put<PaymentActions>({
            type: PaymentActionTypes.PAYPAL_PAYMENT_ERROR,
            error: errorToBasketErrorModel(error, 'paypalSetupPaymentSaga')
        });

        return false;
    }
}

function sendAnalytics(): void {
    analyticsHelper.withLogging(() => {
        analyticsHelper.sendToGooglePaypalPaymentStatus('paypalButton');
    }, 'paypalSetupPaymentSaga');
}
